module.exports = __webpack_public_path__ + "static/OPG-4321e4d35abab38aaca264e19ff2271d.jpeg";